import React from 'react';
import { getParselyRelatedArticlesSlugs } from 'rest/parsely/client';
import difference from 'lodash.difference';
import { captureException } from '@sentry/react';
import { useCookieConsent } from '@zapier/cookies';

export const useRelatedArticleSlugsFromParsely = ({
  slugsToDedupe,
  numberOfArticlesToDisplay,
  section,
  tag,
}: {
  slugsToDedupe: string[];
  numberOfArticlesToDisplay: number;
  section?: string;
  tag?: string;
}) => {
  /**
   * Buffer to account for if a bunch of the articles that Parsely suggests are non-discoverable in Contentful
   */
  const EXTRA_ARTICLES_BUFFER = 10;
  const [slugs, setSlugs] = React.useState<string[]>([]);
  const [error, setError] = React.useState(false);
  const {
    byName: { analytics: analyticsCookies },
  } = useCookieConsent();

  React.useEffect(() => {
    async function getRelatedArticles() {
      try {
        const limit =
          numberOfArticlesToDisplay +
          slugsToDedupe.length +
          EXTRA_ARTICLES_BUFFER;
        const parselySlugs = await getParselyRelatedArticlesSlugs({
          limit,
          section,
          tag,
          analyticsCookiesAccepted: analyticsCookies,
        });
        // set articleSlugs to the slugs that Parsely returned NOT including any that already existing on the consumer
        setSlugs(difference(parselySlugs, slugsToDedupe));
      } catch (e) {
        captureException(e);
        setError(true);
      } finally {
        if (!slugs.length) {
          setError(true);
        }
      }
    }
    getRelatedArticles();
  }, []);

  return { slugs, error };
};
